import { FC } from 'react'

import { Box, Typography } from '@mui/material'

interface IProps {
  title: string
  text?: string
  icon?: any
  children?: any
  backgroundColor?: string
  borderRadius? : string
}

const BoxTitle: FC<IProps> = ({ title, text, icon, children, backgroundColor, borderRadius}) => {
  return (
    <>
      <Typography
        variant='h3'
        sx={{
          margin: '0',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {icon && <span style={{ marginRight: '10px', fontSize: '1rem', lineHeight: '1.5rem' }}>{icon}</span>}
        <span style={{
          fontFamily: 'NewsReader',           
          fontWeight: '400',
          fontSize: '1.4rem',
          }}>{title}</span>
      </Typography>

      <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center'}}>
        {text && (
          <Typography
            sx={{
              fontFamily: 'NewsReader',
              fontWeight: '400',
              fontSize: '1rem',
              marginTop: 2,
              marginBottom: 5,
              padding: '0.5rem',  
              backgroundColor: backgroundColor ? backgroundColor : '',
              borderRadius: borderRadius ? borderRadius : '',
            }}
          >
            {text}
          </Typography>
        )}
         {children}
      </Box>
    </>
  )
}
export default BoxTitle
